import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { AvatarSelector } from '../../common/AvatarSelector';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const AvatarSelectorWidget = (props) => {
    const component = useMemo(() => props.user ? (_jsx(AvatarSelector, { imageContainingVob: props.user, editable: false, userFunctions: props.userFunctions, transactionFunctions: props.transactionFunctions })) : (_jsx(_Fragment, {})), [props.user]);
    return {
        name: 'AvatarSelector',
        category: 'common',
        component,
    };
};
